import React from 'react';

import placeholder from 'images/placeholder.jpg';

export default ({ src, className, alt }) => {
  return <img src={src || placeholder} className={className} alt={alt} draggable={false} />;
};
